"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";
import { useCountryStateCookies } from "hooks/cookies/useCountryStateCookies";

interface RestrictedCountryRedirectProps {
  restrictedCountryList: string[];
}

export function RestrictedCountryRedirect({
  restrictedCountryList
}: RestrictedCountryRedirectProps) {
  const router = useRouter();
  const { country, isUK } = useCountryStateCookies();

  useEffect(() => {
    if (country && restrictedCountryList.includes(country)) {
      if (isUK) {
        router.push("/uk");
      } else {
        router.push("/");
      }
    }
  }, [country, isUK, restrictedCountryList, router]);

  return null;
}
